import { render } from "./banque.vue?vue&type=template&id=5f3c7e64&scoped=true"
import script from "./banque.vue?vue&type=script&lang=js"
export * from "./banque.vue?vue&type=script&lang=js"

import "./banque.vue?vue&type=style&index=0&id=5f3c7e64&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3c7e64"]])

export default __exports__